export { default } from "./tooltip";
export type { TailPlacement } from "./tooltip";
